"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTokenObjectToHtml = void 0;
const transformations_1 = require("../../transformations");
const escape = require('lodash.escape');
const transformTokenObjectToHtml = (tokenObject) => {
    const attributes = transformIntoAttributes(tokenObject, {
        'e-token': { property: 'type', transform: transformations_1.sanitize, defaultValue: '' },
        'token-template': { property: 'template', transform: transformations_1.serialize },
        'token-content': { property: 'content', transform: transformations_1.serialize },
        'token-meta': { property: 'meta', transform: transformations_1.serialize },
        style: { property: 'style', transform: transformations_1.sanitize },
        class: { property: 'class', transform: transformations_1.sanitize },
    });
    return `<span ${attributes.join(' ')}>${escape(tokenObject.name || '')}</span>`;
};
exports.transformTokenObjectToHtml = transformTokenObjectToHtml;
function transformIntoAttributes(data, attributesMap) {
    const attributes = Object.keys(attributesMap)
        .map((attribute) => transformIntoAttribute(data, attribute, attributesMap[attribute]))
        .filter((attribute) => typeof attribute === 'string');
    return attributes;
}
function transformIntoAttribute(data, attribute, options) {
    const { property, transform } = options;
    if (property in data)
        return `${attribute}="${transform(data[property])}"`;
    if ('defaultValue' in options)
        return `${attribute}="${options.defaultValue}"`;
    return;
}
//# sourceMappingURL=transform-token-object-to-html.js.map